import {useDebugValue} from 'react';

import {undef} from '../../../utils';

import {useSettings} from './';

const defaultSettings = {
    isOpen: false,
    isLoading: false,
    isSecondaryActionDisabled: undef
};

function useDetailsModalSettings(props) {
    const {
        detailsModalSettings: propsSettings
    } = props;

    const {
        initialSettings,
        settings,
        changeSettings
    } = useSettings(defaultSettings, propsSettings);

    const result = {
        initialSettings,
        settings,
        changeSettings
    };

    useDebugValue(result);

    return result;
}

export {useDetailsModalSettings};
